import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=5bd92b8d&scoped=true&"
import script from "./settingList.vue?vue&type=script&lang=js&"
export * from "./settingList.vue?vue&type=script&lang=js&"
import style0 from "./settingList.vue?vue&type=style&index=0&id=5bd92b8d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd92b8d",
  null
  
)

export default component.exports